export enum EAvatarSize {

  big = 40,
  medium = 26,
  small = 15
}